import React from 'react'

import { Show, Switch } from '@app/components/util'
import { LntButton } from '@app/components/base'
import { SubheaderToolbarDivider } from '@app/components'

import { BUTTON_TYPE } from '@app/constants'

import styles from './styles.module.scss'

import type { DrawerFooterProps } from './types'

const { Case } = Switch

export const DrawerFooter: React.FC<DrawerFooterProps> = props => {
  const { userIsInitiator, formId, isSubmittingComment, formIsValid, onReject, onApprove, onSelf, onCancel } = props

  return (
    <div className={ styles.internalTaskCardDrawer__footer }>
      <Show condition={ !userIsInitiator }>
        <LntButton
          type={ BUTTON_TYPE.secondary }
          onClick={ onReject }
        >
          Отклонить
        </LntButton>
        <LntButton
          type={ BUTTON_TYPE.secondary }
          onClick={ onApprove }
        >
          Согласовать
        </LntButton>
      </Show>
      <LntButton
        htmlType='submit'
        form={ formId }
        type={ BUTTON_TYPE.secondary }
        disabled={ formIsValid }
        loading={ isSubmittingComment }
      >
        Отправить комментарий
      </LntButton>

      <SubheaderToolbarDivider />

      <Switch
        fallback={
          <LntButton
            type={ BUTTON_TYPE.primary }
            onClick={ onSelf }
          >
            Взять в работу
          </LntButton>
        }
      >
        <Case condition={ userIsInitiator }>
          <LntButton
            type={ BUTTON_TYPE.secondary }
            onClick={ onCancel }
          >
            Отменить задачу
          </LntButton>
        </Case>
      </Switch>
    </div>
  )
}
